import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import * as Icon from 'react-bootstrap-icons';


import { Nav, Navbar,Form,FormControl,Button,NavDropdown } from 'react-bootstrap';
import {Link} from "react-router-dom";


function MyOceanityNav(props :any) {

    const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0()

    const showAuth = () => {
        if(!isLoading) {
            if(isAuthenticated) {
                return (<span className="ml-auto menuNickname"> Hi, {user.nickname}    <Button className="ml-2 login-btn" onClick={() => logout({ returnTo: window.location.origin })}>Sign out</Button></span>);
            }else{
                return (<div className="ml-auto">
                    <Button variant="outline-success" className="ml-2 login-btn" onClick={() => loginWithRedirect()}>Sign In</Button></div>);
            }
        }
    };

    return (
        <div>
            <Navbar fixed={props.fixed} className="navWrapper" bg="dark" variant="dark" expand="lg">
                <Navbar.Brand className="logo" href="/">MYOCEANITY</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">

                    <Nav className="mr-2">
                        <Nav.Link title="My Assessments" id="collasible-nav-dropdown" href="/user/premium/my-assessments" >
                        <div className="navbartext">My Assessments</div>
                        </Nav.Link>
                            {/*<NavDropdown.Item href="/user/premium/quiz"><Icon.StarFill/> Self OCEAN Assessment</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Personal report</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Comparison Invite</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.4">Compare self to others, one by one</NavDropdown.Item>*/}

                    </Nav>
                    <Nav className="mr-2">
                    <Nav.Link title="My Tribe" id="collasible-nav-dropdown" href="/user/premium/send-invite" >
                            <div className="navbartext">My Tribe</div>
                        </Nav.Link>

                    </Nav>
                    <Nav className="mr-2">
                    <Nav.Link title="EI Course" id="collasible-nav-dropdown" href="/ei-course" >
                            <div className="navbartext">Course</div>
                        </Nav.Link>

                    </Nav>
                    <Nav className="mr-2">
                        <Nav.Link title="Contact Us" id="collasible-nav-dropdown" href="/contact" >
                             <div className="navbartext">Contact Us</div>
                        </Nav.Link>
                    </Nav>
                    {showAuth()}
                </Navbar.Collapse>

            </Navbar>

        </div>
    );
}
export default MyOceanityNav;